import { render, staticRenderFns } from "./BulkCreate.vue?vue&type=template&id=2d472941&scoped=true"
import script from "./BulkCreate.vue?vue&type=script&lang=js"
export * from "./BulkCreate.vue?vue&type=script&lang=js"
import style0 from "./BulkCreate.vue?vue&type=style&index=0&id=2d472941&prod&lang=css"
import style1 from "./BulkCreate.vue?vue&type=style&index=1&id=2d472941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d472941",
  null
  
)

export default component.exports